// extracted by mini-css-extract-plugin
export default {"label_spec":"measurementSidebar_label_spec__VXgqV","patient_wound":"measurementSidebar_patient_wound__3HjLh","image_skeleton":"measurementSidebar_image_skeleton__ENt5K"};